.dividerLabel {
    color: var(--mantine-color-placeholder);
    font-size: var(--mantine-font-size-sm);
    /* these override the default divider styles for mantine so we can have a fade and the size prop still works! */
    &:before {
        border-top: none;
        height: var(--divider-size);
        background: linear-gradient(to left, var(--mantine-color-default-border), transparent);
    }
    &:after {
        border-top: none;
        height: var(--divider-size);
        background: linear-gradient(to right, var(--mantine-color-default-border), transparent);
    }
}
